import gsap from 'gsap';

const theme = window.ambidryTheme || {};
const plusSrc = theme.plusIcon || '';
const minusSrc = theme.minusIcon || '';
const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export function initAccordion() {
  const accordion = document.querySelector('[data-accordion]');
  if (!accordion) return;
  if (accordion.classList.contains('brxe-accordion')) return;

  const items = [...accordion.querySelectorAll('details')];
  let animating = false;

  const getPanel = (item) => item.querySelector('.accordion__panel');

  const syncIcon = (item) => {
    const icon = item.querySelector('summary img');
    if (icon) icon.src = item.open ? minusSrc : plusSrc;
  };

  const setOpenPadding = (item, isOpen) => {
    const summary = item.querySelector('summary');
    if (!summary) return;
    summary.style.paddingBottom = isOpen ? '13px' : '';
  };

  const closeItem = (item) => {
    const panel = getPanel(item);
    if (!panel) return Promise.resolve();

    if (prefersReduced) {
      gsap.set(panel, { height: 0, opacity: 1, clearProps: 'opacity' });
      item.open = false;
      setOpenPadding(item, false);
      syncIcon(item);
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      gsap.to(panel, {
        height: 0,
        opacity: 0.35,
        duration: 0.22,
        ease: 'power2.inOut',
        onComplete: () => {
          item.open = false;
          setOpenPadding(item, false);
          gsap.set(panel, { opacity: 1 });
          syncIcon(item);
          resolve();
        },
      });
    });
  };

  const openItem = (item) => {
    const panel = getPanel(item);
    if (!panel) return Promise.resolve();

    item.open = true;
    setOpenPadding(item, true);
    syncIcon(item);

    if (prefersReduced) {
      gsap.set(panel, { height: 'auto', opacity: 1 });
      return Promise.resolve();
    }

    gsap.set(panel, { height: 0, opacity: 0 });

    return new Promise((resolve) => {
      gsap.to(panel, {
        height: 'auto',
        opacity: 1,
        duration: 0.28,
        ease: 'power2.out',
        onComplete: resolve,
      });
    });
  };

  items.forEach((item) => {
    const panel = getPanel(item);
    if (!panel) return;
    if (item.open) {
      gsap.set(panel, { height: 'auto', opacity: 1 });
      setOpenPadding(item, true);
    } else {
      gsap.set(panel, { height: 0, opacity: 1 });
      setOpenPadding(item, false);
    }
    syncIcon(item);
  });

  items.forEach((item) => {
    const summary = item.querySelector('summary');
    summary?.addEventListener('click', async (event) => {
      event.preventDefault();
      if (animating) return;

      if (item.open) {
        animating = true;
        await closeItem(item);
        animating = false;
        return;
      }

      animating = true;
      const openOthers = items.filter((other) => other !== item && other.open);
      await Promise.all(openOthers.map((other) => closeItem(other)));
      await openItem(item);
      animating = false;
    });
  });
}
